<p-dialog
    (onHide)="onHide()"
    (onShow)="onShow()"
    [(visible)]="visible"
    [appendTo]="appendTo"
    [contentStyle]="contentStyle"
    [dismissableMask]="dismissOnClickOutside"
    [draggable]="draggable"
    [minX]="minX"
    [minY]="minY"
    [modal]="blockBackground"
>
    <ng-template #header> {{ (existingUser ? "manageUser.edit" : "manageUser.create") | translate }} </ng-template>

    @if (manageUserForm) {
    <form
        class="p-16"
        id="editUserDialog"
        [formGroup]="manageUserForm"
        novalidate
    >
        <div
            class="m-form-group row"
            [ngClass]="{ 'has-error': manageUserForm.get('firstName').showErrors }"
        >
            <label
                class="col-2"
                for="firstName"
            >
                {{"general.firstName" | translate}}
            </label>
            <div class="col-10">
                <input
                    class="p-inputtext"
                    id="firstName"
                    #firstNameInput
                    formControlName="firstName"
                    type="text"
                />
                <app-form-validation
                    [control]="manageUserForm.get('firstName')"
                    [input]="firstNameInput"
                >
                </app-form-validation>
            </div>
        </div>
        <div
            class="m-form-group row"
            [ngClass]="{ 'has-error': manageUserForm.get('lastName').showErrors }"
        >
            <label
                class="col-2"
                for="lastName"
            >
                {{"general.lastName" | translate}}
            </label>
            <div class="col-10">
                <input
                    class="p-inputtext"
                    id="lastName"
                    #lastNameInput
                    formControlName="lastName"
                    type="text"
                />
                <app-form-validation
                    [control]="manageUserForm.get('lastName')"
                    [input]="lastNameInput"
                >
                </app-form-validation>
            </div>
        </div>
        <div
            class="m-form-group row"
            [ngClass]="{ 'has-error': manageUserForm.get('email').showErrors }"
        >
            <label
                class="col-2"
                for="email"
            >
                {{"general.email" | translate}}
            </label>
            <div class="col-10">
                <input
                    class="p-inputtext"
                    id="email"
                    #emailInput
                    formControlName="email"
                    type="text"
                />
                <app-form-validation
                    [control]="manageUserForm.get('email')"
                    [input]="emailInput"
                >
                </app-form-validation>
            </div>
        </div>
        @if (manageUserForm.get('sendDefaultEmail').enabled) {
        <div
            class="m-form-group row"
            [ngClass]="{ 'has-error': manageUserForm.get('sendDefaultEmail').showErrors }"
        >
            <label
                class="col-2"
                for="sendDefaultEmail"
            >
                {{"manageUser.defaultEmail" | translate}}
            </label>
            <div class="col-10">
                <p-toggle-switch
                    id="sendDefaultEmail"
                    #sendDefaultEmailInput
                    formControlName="sendDefaultEmail"
                >
                </p-toggle-switch>
                <app-form-validation
                    [control]="manageUserForm.get('sendDefaultEmail')"
                    [input]="sendDefaultEmailInput"
                >
                </app-form-validation>
            </div>
        </div>
        }
        <div
            class="m-form-group row"
            [ngClass]="{ 'has-error': manageUserForm.get('languageId').showErrors }"
        >
            <label
                class="col-2"
                for="language"
            >
                {{"general.language" | translate}}
            </label>
            <div class="col-10">
                <p-select
                    id="languageId"
                    [filter]="true"
                    [options]="languages"
                    [panelStyle]="{'min-width':'100%'}"
                    [resetFilterOnHide]="true"
                    #languageIdInput
                    appendTo="body"
                    formControlName="languageId"
                    placeholder="{{'general.language' | translate}}"
                >
                </p-select>
                <app-form-validation
                    [control]="manageUserForm.get('languageId')"
                    [input]="languageIdInput"
                >
                </app-form-validation>
            </div>
        </div>
        <div
            class="m-form-group row"
            [ngClass]="{ 'has-error': manageUserForm.get('phoneNumber').showErrors }"
        >
            <label
                class="col-2"
                for="phoneNumber"
            >
                {{"general.phoneNumber" | translate}}
            </label>
            <div class="col-10">
                <input
                    class="p-inputtext"
                    id="phoneNumber"
                    #phoneNumberInput
                    formControlName="phoneNumber"
                    type="text"
                />
                <app-form-validation
                    [control]="manageUserForm.get('phoneNumber')"
                    [input]="phoneNumberInput"
                >
                </app-form-validation>
            </div>
        </div>
        <div
            class="m-form-group row"
            [ngClass]="{ 'has-error': manageUserForm.get('gsm').showErrors }"
        >
            <label
                class="col-2"
                for="gsm"
            >
                {{"users.gsm" | translate}}
            </label>
            <div class="col-10">
                <input
                    class="p-inputtext"
                    id="gsm"
                    #gsmInput
                    formControlName="gsm"
                    type="text"
                />
                <app-form-validation
                    [control]="manageUserForm.get('gsm')"
                    [input]="gsmInput"
                >
                </app-form-validation>
            </div>
        </div>
        <div
            class="m-form-group row"
            [ngClass]="{ 'has-error': manageUserForm.get('organizations').showErrors }"
        >
            <label
                class="col-2"
                for="organizations"
            >
                {{"general.organizations" | translate}}
            </label>
            <div class="col-10">
                <p-multiSelect
                    id="organizations"
                    [filter]="true"
                    [options]="organizations"
                    [showHeader]="true"
                    [showToggleAll]="false"
                    [style]="{'width':'100%'}"
                    #selectedOrganizationsInput
                    appendTo="body"
                    formControlName="organizations"
                    placeholder="{{'general.organizations' | translate}}"
                >
                </p-multiSelect>
                <app-form-validation
                    [control]="manageUserForm.get('organizations')"
                    [input]="selectedOrganizationsInput"
                >
                </app-form-validation>
            </div>
        </div>
        <div
            class="m-form-group row"
            [formGroup]="rolesForm"
        >
            <label
                class="col-2"
                for="roles"
            >
                {{"general.roles" | translate}}
            </label>
            <div class="col-10">
                <!--loop over roleWithCategory-->
                @for (item of rolesByCategory | keyvalue : returnZero; track item; let i = $index) {
                <div [ngClass]="{'mt-8': i > 0}">
                    <h4>{{item.key | translateEnum:"roleCategory" }}</h4>
                    @for (role of item.value; track role) {
                    <label class="m-input-checkbox-block mt-8">
                        <input
                            id="{{role.roleId}}"
                            formControlName="{{role.roleId}}"
                            type="checkbox"
                        />
                        <span>
                            {{getTranslatableRoleName(role.roleId) | translate}}<br />
                            <span class="m-text-light">{{ getDescriptionText(role.roleId) | translate}}</span>
                        </span>
                    </label>
                    }
                </div>
                }
            </div>
        </div>
    </form>
    }

    <ng-template #footer>
        <button
            class="m-btn m-btn-link"
            id="cancelButton"
            (click)="close()"
            [disabled]="submitting"
            type="button"
        >
            {{ "form.cancel" | translate }}
        </button>

        <button
            class="m-btn m-btn-primary"
            id="saveButton"
            (click)="submit()"
            [disabled]="submitting"
            type="submit"
        >
            @if (submitting) {
            <app-loading-spinner id="manage_user_spinner"> </app-loading-spinner>
            } {{ "form.save" | translate }}
        </button>
    </ng-template>
</p-dialog>
